// Centralized wording for the mechanical entry/exit signals.
// Educational framing — swap here after legal review (e.g. "In"/"Out", "Triggered").
export const ENTRY_LABEL = 'Entry';
export const EXIT_LABEL = 'Exit';
export const EC_LABEL = 'EC';
export const EC_TOOLTIP = 'Entry candidate';
